import {
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { getAllDippingCellData, getDippingCellPopupData } from "./services"; // Import getDippingCellPopupData
import { images } from "../../config/images";
import { toast, ToastContainer } from "react-toastify";
import dayjs from "dayjs";

const DippingCellData = ({startDateReFormat,endDateReFormat,showTime}) => {
  const [dippingCellData, setDippingCellData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [coagulantPopup, setCoagulantPopup] = useState(false);
  const [count, setCount] = useState(0);
 
  const [dippingCellPopupData, setDippingCellPopupData] = useState(null); // New state for Dipping Cell popup data
  const [coagulantPopupData, setCoagulantPopupData] = useState(null); // New state for Coagulant popup data

  const initiallValue = {
    date: "",
    shift: "",
    time: "",
    parameter_type: "",
    d_m_tanks: "",
    lot_no: "",
    temp: "",
    ph: "",
    viscocity: "",
    maturation: "",
    specific_gravity: "",
    foam_test_1: "",
    foam_test_2: "",
    foam_test_3: "",
    remarks_time: "",
    plate_test: "",
    repeated_readings: "",
    hot_conductivity: "",
    cold_conductivity: "",
    operator_name: "",
    supervisor_name: "",
  };

  const [searchText, setSearchText] = useState(initiallValue);
  const [debouncedSearch, setDebouncedSearch] = useState(searchText);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchText);
    }, 500); // 500ms debounce delay

    return () => clearTimeout(handler);
  }, [searchText]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleClose = () => {
    setOpen(false);
    setCoagulantPopup(false); // Close both popups
    setDippingCellPopupData(null); // Clear popup data on close
    setCoagulantPopupData(null); // Clear popup data on close
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const dateFormat = "YYYY-MM-DD";
  const startDateFormat = dayjs(startDateReFormat).format(dateFormat);
  const endDateFormat = dayjs(endDateReFormat).format(dateFormat);
  const DateTimeFormat = (date) => {
    const Date_Time_Format = "YYYY-MM-DD HH:mm:ss";
    // console.log("YYYY-MM-DD hh:mm:ss",dayjs(date).format(Date_Time_Format))
    return dayjs(date).format(Date_Time_Format);
  };

  useEffect(() => {
    handleGetDippingData();
  }, [page, rowsPerPage, debouncedSearch,startDateReFormat,endDateReFormat,showTime]);

  const handleGetDippingData = async () => {
    const searchParams = {
      searchText: debouncedSearch,
      page: page,
      rowsPerPage: rowsPerPage,
    };
    if (startDateReFormat && endDateReFormat) {
        if (showTime) {
          const StartDateTime = DateTimeFormat(startDateReFormat);
          const EndDateTime = DateTimeFormat(endDateReFormat);
          searchParams["start_datetime"] = StartDateTime;
          searchParams["end_datetime"] = EndDateTime;
        } else {
            searchParams["start_datetime"] = `${startDateFormat} 00:00:00`;
            searchParams["end_datetime"] = `${endDateFormat} 23:59:59`;
        }
      }
    try {
      const resp = await getAllDippingCellData(searchParams);
      if (resp.status === 200 || resp.status === 201) {
        setDippingCellData(resp.data.results.payload);
        setCount(resp.data.count);
      }
    } catch (err) {
      setDippingCellData([]);
    }
  };

  const handleSearchData = async (e) => {
    const { name, value } = e.target;
    setSearchText({ ...searchText, [name]: value });
  };

  const handleViewPopup = async (cellId, parameterType) => {
    if (parameterType === "Dipping Cell") {
      setOpen(true);
    } else if (parameterType === "Coagulant") {
      setCoagulantPopup(true);
    }

    const params = { cell_id: cellId, parameter_type: parameterType };
    try {
      const resp = await getDippingCellPopupData(params);
      if (resp.status === 200 || resp.status === 201) {
        if (parameterType === "Dipping Cell") {
          setDippingCellPopupData(resp.data.payload);
         
        } else if (parameterType === "Coagulant") {
          setCoagulantPopupData(resp.data.payload);
          setCoagulantPopup(true);
        
        }
      }
    } catch (err) {
      console.error("Error fetching popup data:", err);
      if (parameterType === "Dipping Cell") {
        setDippingCellPopupData(null);
        toast.error(err.response.data.message);
      } else if (parameterType === "Coagulant") {
        setCoagulantPopupData(null);
        toast.error(err.response.data.message);
      }
    }
  };

  return (
    <>
    <ToastContainer />
      <div>
        <div className="table-responsive">
          <Table
            aria-label="Dipping parameter"
            className="dipping-parameter-table  washing-table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Shift</TableCell>
                <TableCell>Time</TableCell>
                <TableCell>Parameter Type</TableCell>
                <TableCell>D/M Tanks</TableCell>
                <TableCell>LOT No</TableCell>
                <TableCell>Temp</TableCell>
                <TableCell>Ph</TableCell>
                <TableCell>Viscosity</TableCell>
                <TableCell>Maturation</TableCell>
                <TableCell>Specific Gravity</TableCell>
                <TableCell>Foam Test 1</TableCell>
                <TableCell>Foam Test 2</TableCell>
                <TableCell>Foam Test 3</TableCell>
                <TableCell>Remarks Time</TableCell>
                <TableCell>Plate Test</TableCell>
                <TableCell>Repeated Readings</TableCell>
                <TableCell>Hot Conductivity</TableCell>
                <TableCell>Cold Conductivity</TableCell>
                <TableCell>Operator Name</TableCell>
                <TableCell>Supervisor Name</TableCell>
                <TableCell>View</TableCell>
              </TableRow>
              <TableRow>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Date"
                    name="date"
                    value={searchText.date}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Shift"
                    name="shift"
                    value={searchText.shift}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Time"
                    name="time"
                    value={searchText.time}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Paramater Type"
                    name="parameter_type"
                    value={searchText.parameter_type}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="D/m Tanks"
                    name="d_m_tanks"
                    value={searchText.d_m_tanks}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="LOT No"
                    name="lot_no"
                    value={searchText.lot_no}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Temp"
                    name="temp"
                    value={searchText.temp}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Ph"
                    name="ph"
                    value={searchText.ph}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Viscosity"
                    name="viscocity"
                    value={searchText.viscocity}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Maturation"
                    name="maturation"
                    value={searchText.maturation}
                    onChange={handleSearchData}
                  />
                </TableCell>

                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Specific Gravity"
                    name="specific_gravity"
                    value={searchText.specific_gravity}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Foam Test"
                    name="foam_test_1"
                    value={searchText.foam_test_1}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Foam Test"
                    name="foam_test_2"
                    value={searchText.foam_test_2}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Foam Test"
                    name="foam_test_3"
                    value={searchText.foam_test_3}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Remarks Time"
                    name="remarks_time"
                    value={searchText.remarks_time}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Plate Test"
                    name="plate_test"
                    value={searchText.plate_test}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Repeated Readings"
                    name="repeated_readings"
                    value={searchText.repeated_readings}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Hot Conductivity"
                    name="hot_conductivity"
                    value={searchText.hot_conductivity}
                    onChange={handleSearchData}
                  />{" "}
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Cold Conductivity"
                    name="cold_conductivity"
                    value={searchText.cold_conductivity}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Operator Name"
                    name="operator_name"
                    value={searchText.operator_name}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row">
                  <SearchIcon className="search-icon" />
                  <input
                    type="search"
                    placeholder="Supervisor Name"
                    name="supervisor_name"
                    value={searchText.supervisor_name}
                    onChange={handleSearchData}
                  />
                </TableCell>
                <TableCell className="search-table-row"> </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dippingCellData?.map((e) => {
                return (
                  <TableRow key={e.id}>
                    <TableCell>{e.date}</TableCell>
                    <TableCell>{e.shift}</TableCell>
                    <TableCell>{e.time}</TableCell>
                    <TableCell>{e.parameter_type}</TableCell>
                    <TableCell>{e.d_m_tanks}</TableCell>
                    <TableCell>{e.lot_no}</TableCell>
                    <TableCell>{e.temp}</TableCell>
                    <TableCell>{e.ph}</TableCell>
                    <TableCell>{e.viscosity}</TableCell>
                    <TableCell>{e.maturation}</TableCell>
                    <TableCell>{e.specific_gravity}</TableCell>
                    <TableCell>{e.foam_test_1}</TableCell>
                    <TableCell>{e.foam_test_2}</TableCell>
                    <TableCell>{e.foam_test_3}</TableCell>
                    <TableCell>{e.remark_time}</TableCell>
                    <TableCell>{e.plate_test}</TableCell>
                    <TableCell>{e.repeated_reading}</TableCell>
                    <TableCell>{e.hot_conductivity}</TableCell>
                    <TableCell>{e.cold_conductivity}</TableCell>
                    <TableCell>{e.operator_name}</TableCell>
                    <TableCell>{e.supervisor_name}</TableCell>
                    <TableCell>
                      <img
                        src={images.viewIcon}
                        alt=""
                        onClick={() => handleViewPopup(e.cell_id, e.parameter_type)}
                        style={{ cursor: "pointer" }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
        <TablePagination
          className="table-pagination"
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth={false}
          sx={{ "& .MuiDialog-paper": { width: "90%", maxWidth: "none" } }}
        >
          <TableContainer>
            <Table className="reports-dipping-cells">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1d407d", color: "#ffffff" }}>
                  <TableCell colSpan={13} sx={{ color: "white !important" }}>
                    Daily Parameter of Dipping Cells
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={4}>Parameter</TableCell>
                  <TableCell>Temp</TableCell>
                  <TableCell>PH</TableCell>
                  <TableCell>Viscosity</TableCell>
                  <TableCell>Maturation</TableCell>
                  <TableCell>Plate Test</TableCell>
                  <TableCell>Time</TableCell>
                  <TableCell>Repeated Reading</TableCell>
                  <TableCell sx={{ width: "220px" }}>Operator Name</TableCell>
                  <TableCell>Sup(Prod/QA)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Range Section */}
                <TableRow>
                  <TableCell rowSpan={2} colSpan={3}>
                    Range
                  </TableCell>
                  <TableCell>Minimum</TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 0
                      )?.temp
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 0
                      )?.ph
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 0
                      )?.viscosity 
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 0
                      )?.maturation
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 0
                      )?.plate_test
                    }
                  </TableCell>
                  <TableCell>
                    {dippingCellPopupData?.find((data) => data.range_type === 0)
                      ?.created_at
                      ? new Date(
                          dippingCellPopupData.find(
                            (data) => data.range_type === 0
                          ).created_at
                        ).toLocaleTimeString()
                      : ""}
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 0
                      )?.repeated_reading
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 0
                      )?.operator
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 0
                      )?.supervisor
                    }
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Maximum</TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 1
                      )?.temp
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 1
                      )?.ph
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 1
                      )?.viscosity
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 1
                      )?.maturation
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 1
                      )?.plate_test
                    }
                  </TableCell>
                  <TableCell>
                    {dippingCellPopupData?.find((data) => data.range_type === 1)
                      ?.created_at
                      ? new Date(
                          dippingCellPopupData.find(
                            (data) => data.range_type === 1
                          ).created_at
                        ).toLocaleTimeString()
                      : ""}
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 1
                      )?.repeated_reading
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 1
                      )?.operator
                    }
                  </TableCell>
                  <TableCell>
                    {
                      dippingCellPopupData?.find(
                        (data) => data.range_type === 1
                      )?.supervisor
                    }
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>
        <Dialog
          open={coagulantPopup}
          onClose={handleClose}
          maxWidth={false}
          sx={{ "& .MuiDialog-paper": { width: "90%", maxWidth: "none" } }}
        >
          {" "}
          <TableContainer>
            <Table size="small" className="reports-dipping-cells">
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1d407d" }}>
                  <TableCell
                    colSpan={13}
                    align="center"
                    sx={{
                      color: "white !important",
                      borderRight: "1px solid white",
                    }}
                  >
                    Daily Parameter of Coagulant
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell colSpan={2}>Parameter</TableCell>
                  <TableCell>Temp</TableCell>
                  <TableCell>Specific Gravity</TableCell>
                  <TableCell colSpan={3}>Foam Test</TableCell>
                  <TableCell>Remark Time</TableCell>
                  <TableCell>HOT Conductivity (μs/cm)</TableCell>
                  <TableCell> Cold Conductivity (μs/cm)</TableCell>
                  <TableCell>Time</TableCell>
                  <TableCell>Operator Name</TableCell>
                  <TableCell>Sup(Prod/QA)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Range Section */}
                <TableRow>
                  <TableCell rowSpan={2}>Range</TableCell>
                  <TableCell>Minimum</TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 0
                      )?.temp
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 0
                      )?.specific_gravity
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 0
                      )?.foam_test_1
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 0
                      )?.foam_test_2
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 0
                      )?.foam_test_3
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 0
                      )?.remark_time
                    }
                  </TableCell>
                  <TableCell rowSpan={2}>
                    {coagulantPopupData?.hot_conductivity}
                  </TableCell>
                  <TableCell rowSpan={2}>
                    {coagulantPopupData?.cold_conductivity}
                  </TableCell>
                  <TableCell>
                    {coagulantPopupData?.coagulant_range?.find(
                      (data) => data.range_type === 0
                    )?.created_at
                      ? new Date(
                          coagulantPopupData.coagulant_range.find(
                            (data) => data.range_type === 0
                          ).created_at
                        ).toLocaleTimeString()
                      : ""}
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 0
                      )?.operator
                    }
                  </TableCell>
                  <TableCell rowSpan={2}>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 0
                      )?.supervisor
                    }
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Maximum</TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 1
                      )?.temp
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 1
                      )?.specific_gravity
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 1
                      )?.foam_test_1
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 1
                      )?.foam_test_2
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 1
                      )?.foam_test_3
                    }
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 1
                      )?.remark_time
                    }
                  </TableCell>
                  <TableCell>
                    {coagulantPopupData?.coagulant_range?.find(
                      (data) => data.range_type === 1
                    )?.created_at
                      ? new Date(
                          coagulantPopupData.coagulant_range.find(
                            (data) => data.range_type === 1
                          ).created_at
                        ).toLocaleTimeString()
                      : ""}
                  </TableCell>
                  <TableCell>
                    {
                      coagulantPopupData?.coagulant_range?.find(
                        (data) => data.range_type === 1
                      )?.operator
                    }
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>
      </div>
    </>
  );
};
export default DippingCellData;
